<div class="flex justify-content-between">
    <span class="p-input-icon-left">
    </span>
</div>
<hot-table [hotId]="id"
           [settings]="settings"
           [columns]="columns"
           [nestedHeaders]="nestedHeaders"
           [data]="dataset"></hot-table>
